import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Highlight, { Prism } from '@docpocalypse/prism-react-renderer';
import useMergeState from '@restart/hooks/useMergeState';
import useStableMemo from '@restart/hooks/useStableMemo';
import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import SimpleCodeEditor from 'react-simple-code-editor';
import { mapTokens } from './CodeBlock';
import InfoMessage from './InfoMessage';
import { useLiveContext } from './Provider';
var uid = 0;

function useStateFromProp(prop) {
  var state = useState(prop);
  var firstRef = useRef(true);
  useStableMemo(function () {
    if (firstRef.current) {
      firstRef.current = false;
      return;
    }

    state[1](prop);
  }, [prop]);
  return state;
}

var Editor = React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      theme = _ref.theme,
      _ref$infoComponent = _ref.infoComponent,
      Info = _ref$infoComponent === void 0 ? InfoMessage : _ref$infoComponent,
      lineNumbers = _ref.lineNumbers;

  var _useLiveContext = useLiveContext(),
      contextCode = _useLiveContext.code,
      contextTheme = _useLiveContext.theme,
      language = _useLiveContext.language,
      onChange = _useLiveContext.onChange,
      error = _useLiveContext.error;

  var userTheme = theme || contextTheme;

  var _useStateFromProp = useStateFromProp(contextCode),
      _useStateFromProp2 = _slicedToArray(_useStateFromProp, 2),
      code = _useStateFromProp2[0],
      setCode = _useStateFromProp2[1];

  var mouseDown = useRef(false);
  useLayoutEffect(function () {
    onChange(code || '');
  }, [code, onChange]);

  var _useMergeState = useMergeState({
    visible: false,
    ignoreTab: false,
    keyboardFocused: false
  }),
      _useMergeState2 = _slicedToArray(_useMergeState, 2),
      _useMergeState2$ = _useMergeState2[0],
      visible = _useMergeState2$.visible,
      ignoreTab = _useMergeState2$.ignoreTab,
      keyboardFocused = _useMergeState2$.keyboardFocused,
      setState = _useMergeState2[1];

  var id = useMemo(function () {
    return "described-by-".concat(++uid);
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var key = event.key;

    if (ignoreTab && key !== 'Tab' && key !== 'Shift') {
      if (key === 'Enter') event.preventDefault();
      setState({
        ignoreTab: false
      });
    }

    if (!ignoreTab && key === 'Escape') {
      setState({
        ignoreTab: true
      });
    }
  };

  var handleFocus = function handleFocus(e) {
    if (e.target !== e.currentTarget) return;
    setState({
      visible: true,
      ignoreTab: !mouseDown.current,
      keyboardFocused: !mouseDown.current
    });
  };

  var handleBlur = function handleBlur(e) {
    if (e.target !== e.currentTarget) return;
    setState({
      visible: false
    });
  };

  var handleMouseDown = function handleMouseDown() {
    mouseDown.current = true;
    setTimeout(function () {
      mouseDown.current = false;
    });
  };

  var highlight = useCallback(function (value) {
    return /*#__PURE__*/React.createElement(Highlight, {
      theme: userTheme,
      Prism: Prism,
      code: value,
      language: language
    }, function (hl) {
      return mapTokens(_objectSpread({}, hl, {
        lineNumbers: lineNumbers,
        errorLocation: error === null || error === void 0 ? void 0 : error.location
      }));
    });
  }, [userTheme, language, lineNumbers, error]);
  var baseTheme = userTheme && typeof userTheme.plain === 'object' ? userTheme.plain : {};
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(SimpleCodeEditor, {
    value: code || '',
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown,
    onValueChange: setCode,
    highlight: highlight,
    ignoreTabKey: ignoreTab,
    className: className,
    "aria-describedby": id,
    "aria-label": "Example code editor",
    style: _objectSpread({}, baseTheme, {}, style)
  }), visible && (keyboardFocused || !ignoreTab) && /*#__PURE__*/React.createElement(Info, {
    id: id,
    "aria-live": "polite"
  }, ignoreTab ? /*#__PURE__*/React.createElement(React.Fragment, null, "Press ", /*#__PURE__*/React.createElement("kbd", null, "enter"), " or type a key to enable tab-to-indent") : /*#__PURE__*/React.createElement(React.Fragment, null, "Press ", /*#__PURE__*/React.createElement("kbd", null, "esc"), " to disable tab trapping")));
});
export default Editor;